// extracted by mini-css-extract-plugin
module.exports = {"label":"pre-radio_label__2HK55","required":"pre-radio_required__1MGj9"};